import React from 'react';

import { MorpheusSuggestionsContent } from 'features/chat/config/types/Message';
import { SendMorpheusMessage } from 'features/chat/config/types/types';

import { ChatMessageMorpheusSuggestions } from './MorpheusSuggestions';

type MorpheusSuggestionsMessageProps = {
  content: MorpheusSuggestionsContent;
  sendMorpheusMessage: SendMorpheusMessage;
};

export function MorpheusSuggestionsMessage({
  content,
  sendMorpheusMessage,
}: MorpheusSuggestionsMessageProps) {
  return (
    <ChatMessageMorpheusSuggestions
      suggestions={content.suggestions}
      onSuggestionSelect={(prompt) => {
        sendMorpheusMessage(prompt, content.suggestionForMessageId);
      }}
    />
  );
}
